import {
  useAppleMapkitWebExperiment,
  useExposeAppleMapkitWebExperiment,
} from 'experiments/use-enable-apple-mapkit-web-experiment';

import { IUseMapArgs, IUseMapHook } from './types';
import useMapAppleAdapter from './use-map-apple-adapter.web';
import useMapGoogle from './use-map-google.web';

/**
 * Main useMap hook that conditionally uses Apple MapKit or Google Maps
 * based on the enable-apple-mapkit-web Amplitude experiment.
 *
 * Waits for experiment readiness before initializing either provider.
 * Only one map provider is initialized at a time based on the assignment.
 */
const useMap: IUseMapHook = (args: IUseMapArgs = {}) => {
  const { isReady, isTreatment, hasResolvedVariant } = useAppleMapkitWebExperiment();

  useExposeAppleMapkitWebExperiment(isReady && hasResolvedVariant);

  const enabledAppleMapkit = isReady && isTreatment;
  const enabledGoogleMaps = isReady && !isTreatment;

  const appleResult = useMapAppleAdapter(args, enabledAppleMapkit);
  const googleResult = useMapGoogle(args, enabledGoogleMaps);

  return enabledAppleMapkit ? appleResult : googleResult;
};

export default useMap;
